const getBmiStatus = function () {
  const bmi = getAnswersData('bmi');
  let bmiPhase;

  if (bmi <= 18) {
    bmiPhase = 'underweight';
  } else if (bmi > 18 && bmi <= 25) {
    bmiPhase = 'normal';
  } else if (bmi > 25 && bmi <= 30) {
    bmiPhase = 'overweight';
  } else if (bmi > 30 && bmi <= 35) {
    bmiPhase = 'obesity-one';
  } else if (bmi > 35 && bmi <= 40) {
    bmiPhase = 'obesity-two';
  } else {
    bmiPhase = 'obesity-three';
  }

  return bmiPhase;
};

const changeBmiPhase = function (bmiStatus) {
  const underweight = document.getElementById('bmi-text-2');
  const normal = document.getElementById('bmi-text-3');
  const overweight = document.getElementById('bmi-text-4');
  const obesityOne = document.getElementById('bmi-text-5');
  const obesityTwo = document.getElementById('bmi-text-6');
  const obesityThree = document.getElementById('bmi-text-7');

  if (bmiStatus === 'underweight' && underweight) {
    underweight.classList.remove('hidden-bmi');
  } else if (bmiStatus === 'normal' && normal) {
    normal.classList.remove('hidden-bmi');
  } else if (bmiStatus === 'overweight' && overweight) {
    overweight.classList.remove('hidden-bmi');
  } else if (bmiStatus === 'obesity-one' && obesityOne) {
    obesityOne.classList.remove('hidden-bmi');
  } else if (bmiStatus === 'obesity-two' && obesityTwo) {
    obesityTwo.classList.remove('hidden-bmi');
  } else {
    if (obesityThree) {
      obesityThree.classList.remove('hidden-bmi');
    }
  }
};

export { getBmiStatus, changeBmiPhase };
